import { Injectable, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { DEFAULT_PAGINATE_OPTIONS_LIST, PaginateData, PaginateOptions } from '../utils/paginate.utils';
import { ApiService } from '../core/api.service';
import { PaginationService } from './services/pagination.service';
@Injectable({
  providedIn: 'any'
})
export abstract class BaseList <T> implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();

  abstract apiService: ApiService<T>;
  skip: number = 0;
  take: number = 50;
  dataFetch!: PaginateData<T>;
  totalItems: number = 0;
  fieldToFilter !: string;
  valueToFilter !: any
  abstract paginateOptions:PaginateOptions;
  // Clave única para cada entidad/lista
  abstract entityKey: string;
  protected paginationService = inject(PaginationService);
  pageIndex: number = 0;

  ngOnInit() {
    // Recupera el pageIndex desde el servicio
    this.pageIndex = this.paginationService.getPageIndex(this.entityKey);
    this.skip = this.pageIndex * this.take;
    // Crear una copia local de las opciones de paginación para evitar modificar el objeto global
    this.paginateOptions = { ...this.paginateOptions };
    this.paginateOptions.skip = this.skip;
    this.paginateOptions.take = this.take;
    if(this.fieldToFilter && this.valueToFilter !== null && this.valueToFilter !== undefined) {
      this.paginateOptions.mainFilterField = this.fieldToFilter;
      this.paginateOptions.mainValueToFilter = this.valueToFilter;
    }
    const sub = this.apiService.getData(this.paginateOptions, true).subscribe(data => {
      this.dataFetch = data;
      this.totalItems = this.dataFetch.total_items;
    });
    this.subscriptions.add(sub);
  }
  fetchData = (data: PaginateOptions = { ...this.paginateOptions }, ignoreCache: boolean = false) => {
    //si existen los campos para filtrar, agregarlos a las opciones de consulta
    if(this.fieldToFilter && this.valueToFilter !== null && this.valueToFilter !== undefined) {
      data = { ...data, mainFilterField: this.fieldToFilter, mainValueToFilter: this.valueToFilter };
    }
    // Guarda el pageIndex en el servicio y actualiza la propiedad
    if (data.skip !== undefined && data.take !== undefined) {
      const page = Math.floor(data.skip / data.take);
      this.paginationService.setPageIndex(this.entityKey, page);
      this.pageIndex = page; // <-- Actualiza el pageIndex
    }
    const sub = this.apiService.getData(data , ignoreCache).subscribe(data => {
      // Asignar SIEMPRE un nuevo objeto para disparar ngOnChanges en Table
      this.dataFetch = { ...data };
      this.totalItems = this.dataFetch.total_items;
    });
    this.subscriptions.add(sub);
    return sub;
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.fieldToFilter = '';
    this.valueToFilter = null;
  }
}
